module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-page"
  }, [_c('div', {
    attrs: {
      "id": "pano"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-list",
    attrs: {
      "id": "menuItems"
    }
  }, _vm._l((_vm.menus), function(menu, index) {
    return _c('span', {
      key: index,
      staticClass: "menu-item",
      on: {
        "click": function($event) {
          return _vm.menuBtnClick(menu)
        }
      }
    }, [_vm._v(_vm._s(menu.name))])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75491ef5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MobileIndex.vue
// module id = 1076
// module chunks = 1